import React, { createContext, useContext, useState } from "react";

const DrawerContext = createContext();

export const useDrawerContext = () => useContext(DrawerContext);

export const DrawerProvider = ({ children }) => {
  const [drawerData, setDrawerData] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <DrawerContext.Provider value={{ drawerData, setDrawerData, isDrawerOpen, setIsDrawerOpen }}>
      {children}
    </DrawerContext.Provider>
  );
}; 